const doctorSnippets = document.querySelectorAll('.doctor-snippet');
if(doctorSnippets && doctorSnippets.length > 1) {
	doctorSnippets[0].parentNode.classList.add('multiple-doctors');
}

const isSpanish = document.documentElement.lang.toLowerCase().startsWith('es');

const tabLabels = isSpanish
	? {
		location_about: 'Información',
		reviews_carousel: 'Opiniones',
		treatment_cards: 'Tratamientos',
		conditions: 'Condiciones',
		location_stats: 'Por qué elegirnos',
		insurance: 'Seguros',
		what_to_expect: 'Qué esperar',
		contact_faq: 'Preguntas',
		book_form: 'Reservar'
	}
	: {
		location_about: 'About',
		reviews_carousel: 'Reviews',
		treatment_cards: 'Treatments',
		conditions: 'Conditions We Treat',
		location_stats: 'Why Us',
		insurance: 'Insurance',
		what_to_expect: 'What to Expect',
		contact_faq: 'FAQs',
		book_form: 'Book Now'
	};

const TABS_HEIGHT = 37;
const MOBILE_BREAKPOINT = 767;
const main = document.querySelector('main');

if (main) {
	let isMobileTabs = window.innerWidth <= 1200;
	const tabMap = new Map();
	const sectionList = [];
	let ticking = false;
	let isClickScrolling = false;
	let lastCenteredTab = null;

	function getHeaderOffset() {
		const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
		const el = document.getElementById(isMobile ? 'nav-wrap' : 'header');
		return el ? el.offsetHeight : isMobile ? 80 : 140;
	}

	function getActiveOffset() {
		return getHeaderOffset() + TABS_HEIGHT;
	}

	function centerTab(tab) {
		if (!isMobileTabs) return;

		container.scrollTo({
			left: Math.max(
				0,
				Math.min(
					tab.offsetLeft -
						container.clientWidth / 2 +
						tab.clientWidth / 2,
					container.scrollWidth - container.clientWidth
				)
			),
			behavior: 'smooth'
		});
	}

	function resolveBackground(section) {
		const bg = getComputedStyle(section).backgroundColor;

		return (
			bg &&
			bg !== 'rgba(0, 0, 0, 0)' &&
			bg !== 'transparent'
		)
			? bg
			: getComputedStyle(document.body).backgroundColor;
	}

	function updateTabsLayout() {
		const newIsMobileTabs = window.innerWidth <= 1200;

		if (newIsMobileTabs !== isMobileTabs) {
			isMobileTabs = newIsMobileTabs;
			lastCenteredTab = null;

			if (isMobileTabs) {
				Object.assign(container.style, {
					overflowX: 'auto',
					webkitOverflowScrolling: 'touch',
					scrollBehavior: 'smooth',
					scrollbarWidth: 'none',
					msOverflowStyle: 'none'
				});

				tabMap.forEach((tab) => {
					Object.assign(tab.style, {
						flex: '0 0 auto',
						padding: '8px 29px'
					});
				});
			} else {
				Object.assign(container.style, {
					overflowX: '',
					webkitOverflowScrolling: '',
					scrollBehavior: '',
					scrollbarWidth: '',
					msOverflowStyle: ''
				});

				tabMap.forEach((tab) => {
					Object.assign(tab.style, {
						flex: '',
						padding: '8px 29px'
					});
				});

				container.scrollLeft = 0;
			}
		}

		tabsSection.style.top = `${getHeaderOffset()}px`;
	}

	function updateActiveTab() {
		const lastSectionRect = lastSection.getBoundingClientRect();
		
		if (lastSectionRect.bottom <= getHeaderOffset() + TABS_HEIGHT) {
			tabsSection.style.opacity = '0';
			tabsSection.style.pointerEvents = 'none';
			return;
		}
	
		tabsSection.style.opacity = '1';
		tabsSection.style.pointerEvents = 'auto';
	
		let activeSection = null;
		const threshold = getHeaderOffset() + TABS_HEIGHT + 2;
	
		for (const section of sectionList) {
			if (section.getBoundingClientRect().top <= threshold) {
				activeSection = section;
			} else {
				break;
			}
		}
	
		if (!activeSection) {
			activeSection = sectionList[0];
		}
	
		tabMap.forEach((t) => {
			t.style.fontWeight = '500';
			t.style.color = '#000';
			t.style.boxShadow = 'inset 0 -1px transparent';
		});
	
		const activeTab = tabMap.get(activeSection);
	
		if (activeTab) {
			activeTab.style.fontWeight = '700';
			activeTab.style.color = '#000';
			activeTab.style.fontStyle = 'bold';
			activeTab.style.boxShadow = 'inset 0 -2px #000';
		
			if (
				isMobileTabs &&
				!isClickScrolling &&
				activeTab !== lastCenteredTab
			) {
				centerTab(activeTab);
				lastCenteredTab = activeTab;
			}
		}
	
		const isBookNow = activeSection.id === 'book_form' ||
			Array.from(activeSection.classList).includes('book_form');
	
		const isDesktop = window.innerWidth > 1200;
	
		tabsSection.style.backgroundColor = (isBookNow && isDesktop)
			? '#DFF5FF'
			: resolveBackground(activeSection);
	}

	const spacer = Object.assign(
		document.createElement('div'),
		{
			className: 'tabs-spacer'
		}
	);

	Object.assign(spacer.style, {
		height: '50px',
		width: '100%',
		backgroundColor: '#fff'
	});

	const container = Object.assign(
		document.createElement('div'),
		{
			className: 'container'
		}
	);

	Object.assign(container.style, {
		display: 'flex',
		justifyContent: 'space-between',
		maxWidth: '78.75rem',
		width: '100%',
		marginLeft: 'auto',
		marginRight: 'auto',
		paddingLeft: '1.25rem',
		paddingRight: '1.25rem',
		boxSizing: 'border-box',
		borderBottom: '1px solid rgba(0,0,0,0.15)',
		...(isMobileTabs && {
			overflowX: 'auto',
			webkitOverflowScrolling: 'touch',
			scrollBehavior: 'smooth',
			scrollbarWidth: 'none',
			msOverflowStyle: 'none'
		})
	});

	const tabsSection = Object.assign(
		document.createElement('section'),
		{
			className: 'location-tabs'
		}
	);

	Object.assign(tabsSection.style, {
		position: 'sticky',
		top: `${getHeaderOffset()}px`,
		zIndex: '1000',
		backgroundColor: '#fff',
		transition: 'opacity 250ms ease',
		overflow: 'hidden'
	});

	Array.from(main.children).forEach((section, index) => {
		const key =
			section.id && tabLabels[section.id]
				? section.id
				: Array.from(section.classList).find(
					(c) => tabLabels[c]
				);

		if (!key) return;

		if (!section.dataset.tabId) {
			section.dataset.tabId = `tab-section-${index}`;
		}

		sectionList.push(section);

		const tab = document.createElement('button');
		tab.type = 'button';
		tab.textContent = tabLabels[key];

		Object.assign(tab.style, {
			height: '37px',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			fontSize: isSpanish ? '13px' : '14px',
			border: 'none',
			borderBottom: 'none',
			boxShadow: 'inset 0 -1px transparent',
			background: 'none',
			cursor: 'pointer',
			fontWeight: '400',
			color: '#666',
			whiteSpace: 'nowrap',
			transition:
				'color 250ms ease, font-weight 250ms ease, border-bottom-color 250ms ease',
			...(isMobileTabs
				? {
						flex: '0 0 auto',
						padding: '8px 29px'
					}
				: {
						padding: '8px 29px'
					})
		});

		tab.addEventListener('mouseenter', () => {
			if (tab.style.fontWeight !== '700') {
				tab.style.color = '#fc9191';
			}
		});

		tab.addEventListener('mouseleave', () => {
			if (tab.style.fontWeight !== '700') {
				tab.style.color = '#000';
			}
		});

		tab.addEventListener('click', () => {
			isClickScrolling = true;

			if (isMobileTabs) {
				centerTab(tab);
				lastCenteredTab = tab;
			}

			window.scrollTo({
				top:
					section.getBoundingClientRect().top +
					window.pageYOffset -
					getActiveOffset(),
				behavior: 'smooth'
			});

			setTimeout(() => {
				isClickScrolling = false;
			}, 700);
		});

		tabMap.set(section, tab);
		container.appendChild(tab);
	});

	const lastSection = sectionList[sectionList.length - 1];

	tabsSection.appendChild(container);

	main.parentNode.insertBefore(spacer, main);
	main.parentNode.insertBefore(tabsSection, main);

	window.addEventListener(
		'scroll',
		() => {
			if (!ticking) {
				window.requestAnimationFrame(() => {
					updateActiveTab();
					ticking = false;
				});

				ticking = true;
			}
		},
		{ passive: true }
	);

	let resizeTimeout;

	window.addEventListener('resize', () => {
		clearTimeout(resizeTimeout);

		resizeTimeout = setTimeout(() => {
			updateTabsLayout();
			updateActiveTab();
		}, 100);
	});

	updateTabsLayout();
	updateActiveTab();
}

// document.querySelectorAll('.smart-directions').forEach(function(link) {
// 	var isApple = /iPhone|iPad|iPod/.test(navigator.userAgent);
// 	// var isMac = /Mac/.test(navigator.platform) && navigator.maxTouchPoints > 1;
// 	var isAndroid = /Android/.test(navigator.userAgent);

// 	if (isApple) {
// 		link.href = link.dataset.appleUrl;
// 	} else if (isAndroid) {
// 		link.href = 'intent://maps.google.com/maps?daddr=' + link.dataset.address + '#Intent;scheme=https;package=com.google.android.apps.maps;end';
// 	}
// });

document.querySelectorAll('.share-button').forEach(function(btn) {
	if (navigator.share) {
		btn.addEventListener('click', function() {
			navigator.share({
				title: document.title,
				url: window.location.href
			});
		});
	} else if (navigator.clipboard) {
		btn.style.position = 'relative';

		var tooltip = document.createElement('div');
		tooltip.innerText = 'Link Copied!';
		tooltip.style.cssText = 'position:absolute;bottom:calc(100% + 8px);left:50%;transform:translateX(-50%);background:#333;color:#fff;font-size:12px;padding:5px 10px;border-radius:6px;white-space:nowrap;opacity:0;transition:opacity 0.2s;pointer-events:none;';
		btn.appendChild(tooltip);

		btn.addEventListener('click', function() {
			navigator.clipboard.writeText(window.location.href).then(function() {
				tooltip.style.opacity = '1';
				setTimeout(function() {
					tooltip.style.opacity = '0';
				}, 2000);
			});
		});
	}
});